export enum CourseStepEnum {
  lecture = 'lecture',
  quiz = 'quiz',
  assignment = 'assignment',
}
